import axios from "axios";

export default {
  name: 'home',
  mixins: [],
  extends: {},
  components: {
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.init();
  },
  updated() { },
  beforeDestroy() { },
  methods: {
    // 初始化
    init() {
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/home.js